import { generateMedia, pxToRem } from "styled-media-query";

const media = generateMedia(pxToRem({
    desktop: "1023px",
    medium: "768px",
    mobile: "320px"
}));

export default media;
